import { post } from './client';
import { ROUTES } from './config';
import type { ApiEnvelope } from '@/types/types';

export interface EstimatePrice {
    id?: string;
    name?: string;
    price?: number | null;
}

export interface EstimateServiceDetails {
    id?: number;
    service_type?: string | null;
    repair_type?: string | null;
    part?: string | null;
    position?: string | null;
}

export interface EstimateEntry {
    service_details: EstimateServiceDetails;
    prices?: EstimatePrice[];
}

export interface EstimatePayload {
    location_id: string;
    vehicle: { vin: string };
    services: Array<{ estimates: EstimateEntry[] }>;
}

export interface EstimateRequest {
    vehicle: { vin: string };
    location_id: string;
    services: Array<{ service_details: { service_type: string } }>;
}

export const estimateApi = {
    get: (body: EstimateRequest) => post<ApiEnvelope<EstimatePayload>>(ROUTES.ESTIMATE, body),
};
